export function validarSenhaFrontend(senha = "") {
  const valor = String(senha);

  if (valor.length < 8) {
    return {
      valida: false,
      mensagem: "A senha deve ter pelo menos 8 caracteres."
    };
  }

  if (!/[A-Za-z]/.test(valor)) {
    return {
      valida: false,
      mensagem: "A senha deve conter pelo menos uma letra."
    };
  }

  if (!/\d/.test(valor)) {
    return {
      valida: false,
      mensagem: "A senha deve conter pelo menos um número."
    };
  }

  return {
    valida: true,
    mensagem: null
  };
}

export function calcularForcaSenha(senha = "") {
  const valor = String(senha);

  if (!valor) {
    return {
      nivel: "",
      texto: ""
    };
  }

  let pontos = 0;

  if (valor.length >= 8) pontos++;
  if (valor.length >= 12) pontos++;
  if (/[A-Za-z]/.test(valor) && /\d/.test(valor)) pontos++;
  if (/[a-z]/.test(valor) && /[A-Z]/.test(valor)) pontos++;
  if (/[^A-Za-z0-9]/.test(valor)) pontos++;

  if (pontos <= 2) {
    return {
      nivel: "fraca",
      texto: "Fraca"
    };
  }

  if (pontos <= 3) {
    return {
      nivel: "media",
      texto: "Média"
    };
  }

  return {
    nivel: "forte",
    texto: "Forte"
  };
}